import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import createCache from '@emotion/cache';
import { CacheProvider as MuiCacheProvider } from '@emotion/react';
import { CacheProvider } from '@ipen-portal/plugin-common-react';
import { TssCacheProvider } from 'tss-react';

const muiCache = createCache({ key: 'mui', prepend: true });
const tssCache = createCache({ key: 'tss' });
export const CacheExtension = AppRootWrapperBlueprint.make({
  name: 'cache-barrier',
  params: {
    component: ({ children }) => (
      <CacheProvider>
        <MuiCacheProvider value={muiCache}>
          <TssCacheProvider value={tssCache}>{children}</TssCacheProvider>
        </MuiCacheProvider>
      </CacheProvider>
    ),
  },
});
